import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=57730a9a"
import script from "./logout.vue?vue&type=script&lang=js"
export * from "./logout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57730a9a')) {
      api.createRecord('57730a9a', component.options)
    } else {
      api.reload('57730a9a', component.options)
    }
    module.hot.accept("./logout.vue?vue&type=template&id=57730a9a", function () {
      api.rerender('57730a9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/logout.vue"
export default component.exports